export const ALERT_BUTTON_ANIMATION_KEY = "alert_button_animation_shown";
export const ANIMATION_START_DELAY = 1500;
